import { ADMIN_CHANGE_DASHBOARD_TAB } from '../actions';

export const changeActiveTab = (activeTab) => {
  return {
    type: ADMIN_CHANGE_DASHBOARD_TAB,
    payload: activeTab,
  };
};
